'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';

export const reportsModule = angular
  .module('app.entityManagement', [])
  .config(reportsConfig);

reportsConfig.$inject = ['$routeProvider'];

function reportsConfig($routeProvider) {
  $routeProvider
    .when('/entities-list', {
      template: '<ngz-entity-list list-mode="NUTRITION"></ngz-entity-list>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/entities-list/scan-iq', {
      template: '<ngz-entity-list list-mode="SCAN_IQ"></ngz-entity-list>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/entity-setup-flow-2024', {
      template: '<ngz-entity-flow-2024-setup></ngz-entity-flow-2024-setup>',
      resolve: getLoginRequiredResolveObj(),
    })
  
}